module.exports = __webpack_public_path__ + "img/apidays-3.d07e7aec.png";